import Button from 'components/base/Button';
import React, { useState } from 'react';
import { FormCheck } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { resetRecruiter } from 'reducers/AuthReducer';
import { useRegisterRecruiterMutation } from 'service/authQuery/authQuery';
import { RootState } from 'store/rootReducer';

function Verification() {
  const [isAgree, setIsAgree] = useState(false);
  const [register, { isLoading }] = useRegisterRecruiterMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const recruiter = useSelector(
    (state: RootState) => state.auth.register.recruiter
  );

  const handleSubmit = () => {
    register(recruiter)
      .unwrap()
      .then(response => {
        const id = response?.data?._id;
        dispatch(resetRecruiter());
        navigate(`/verify/sent/recruiter/${id}`);
      })
      .catch(error => {
        console.log(error);
      });
  };
  return (
    <>
      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Verification</div>
      </div>
      <FormCheck type="checkbox" className="mb-3">
        <FormCheck.Input
          type="checkbox"
          name="termsService"
          id="termsService"
          checked={isAgree}
          onChange={e => setIsAgree(e.target.checked)}
        />
        <FormCheck.Label
          htmlFor="termsService"
          className="fs-9 text-transform-none"
        >
          I accept the <Link to="#!">terms </Link>and{' '}
          <Link to="#!">privacy policy</Link>
        </FormCheck.Label>
      </FormCheck>
      <Button
        variant="primary"
        className="w-100 mb-3"
        onClick={handleSubmit}
        loading={isLoading}
        loadingPosition="start"
        disabled={!isAgree || isLoading}
      >
        Sign Up
      </Button>
    </>
  );
}

export default Verification;
